import { memo } from 'react';
import { Ban, Sparkles } from 'lucide-react';
import type { PlayerStats } from '../../types/player';
import { cn } from '../../utils/cn';

interface StaffPlayerBadgesProps {
  stats: PlayerStats | null;
  className?: string;
}

/** Ban / booster flags from the linked player record. */
export const StaffPlayerBadges = memo(({ stats, className }: StaffPlayerBadgesProps) => {
  if (!stats || (!stats.banned && !stats.isserverbooster)) return null;
  return (
    <span className={cn('inline-flex flex-wrap gap-1', className)}>
      {stats.banned && (
        <span className="inline-flex items-center gap-1 h-5 px-2 rounded-full text-[10px] font-semibold border bg-red-500/20 text-red-300 border-red-500/30">
          <Ban className="w-3 h-3" aria-hidden="true" />
          Banned
        </span>
      )}
      {stats.isserverbooster ? (
        <span className="inline-flex items-center gap-1 h-5 px-2 rounded-full text-[10px] font-semibold border bg-purple-500/20 text-purple-300 border-purple-500/30">
          <Sparkles className="w-3 h-3" aria-hidden="true" />
          Booster
        </span>
      ) : null}
    </span>
  );
});

StaffPlayerBadges.displayName = 'StaffPlayerBadges';
